import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/esnext.json.parse.js";
export default {
  name: 'enshizhoulist',
  data() {
    return {
      heightdata: false,
      List: [],
      defaultdataList: [],
      formObj: {
        level: '',
        category: '',
        address: '',
        title: ''
      },
      otherObj: {
        type: '',
        title: ''
      },
      listStyle: {},
      upFlag: false,
      loading: true
    };
  },
  props: ['listshowflag', 'isMobile', 'formoption', 'datalist', 'typeindex', 'otheroption', 'recordtype'],
  components: {},
  computed: {
    bothHaveValue() {
      return this.datalist && this.datalist.length > 0 && this.formoption && Object.keys(this.formoption).length > 0;
    }
  },
  watch: {
    // 监听计算属性
    bothHaveValue(newVal) {
      if (newVal) {
        const copyList = [...this.datalist];
        const levelPriority = new Map();
        const sortedData = [...this.formoption.level].sort((a, b) => parseInt(a.order) - parseInt(b.order));
        sortedData.forEach((item, index) => {
          levelPriority.set(item.title, index);
        });
        this.List = copyList.sort((a, b) => {
          return levelPriority.get(a.itemformdata.level) - levelPriority.get(b.itemformdata.level);
        });
        this.defaultdataList = [...this.List];
        if (this.List.length > 0) this.loading = false;
        Object.keys(this.formObj).forEach(key => {
          this.formObj[key] = '';
        });
        Object.keys(this.otherObj).forEach(key => {
          this.otherObj[key] = '';
        });
      }
    },
    'style': {
      handler(val) {
        this.listStyle = {
          ...val
        };
        delete this.listStyle.width;
      },
      deep: true
    }
  },
  mounted() {},
  methods: {
    gosearch() {
      let filters = {};
      if (this.typeindex === 1) {
        Object.keys(this.formObj).forEach(key => {
          filters[key] = this.formObj[key] === '' ? [] : this.formObj[key].toString().split(',');
        });
      } else {
        Object.keys(this.otherObj).forEach(key => {
          filters[key] = this.otherObj[key] === '' ? [] : this.otherObj[key].toString().split(',');
        });
      }
      let cacheData = JSON.parse(JSON.stringify(this.defaultdataList));
      let filterArray = this.multiFilter(cacheData, filters);
      let data = JSON.parse(JSON.stringify(filterArray));
      this.List = data.map(item => {
        item.itemformdata.title = item.itemformdata.title.replace(/\ufe35/g, '\uff08');
        item.itemformdata.title = item.itemformdata.title.replace(/\ufe36/g, '\uff09');
        return item;
      });
    },
    // 静态数据筛选
    multiFilter(array, filters) {
      const filterKeys = Object.keys(filters);
      return array.filter(item => {
        return filterKeys.every(key => {
          const filterValue = filters[key];
          const itemData = item.itemformdata[key];
          if (!filterValue?.length) return true;
          if (key === 'title') {
            return itemData?.includes(filterValue);
          }
          if (key === 'address') {
            return itemData?.[0]?.val?.includes(filterValue);
          }
          return filterValue.includes(itemData);
        });
      });
    },
    listmarkerclick(item) {
      this.$emit('listclick', item);
    },
    listUp() {
      this.upFlag = !this.upFlag;
      this.$emit('listup', this.upFlag);
    },
    listDown() {
      this.upFlag = false;
    },
    optlevelSort(data) {
      if (data === undefined) return;
      const sortData = data.sort((a, b) => parseInt(a.order) - parseInt(b.order));
      return sortData;
    }
  }
};